// extracted by mini-css-extract-plugin
export default {"row":"K86v5Um5lYEQiEb40OYm","title":"bT7wOAltSTKXhAhXPfCP","titleIcon":"QBe2FMN7tRHQRU12dOo2","details":"ZJlBPjjPNw1s0sJSbelo"};